import React from 'react';
import styled from 'styled-components';
import { UserInfo } from './UserInfo.tsx';

const ProfilePage: React.FC = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <ProfileContent>
          <UserInfo />
        </ProfileContent>
      </ContentWrapper>
    </PageContainer>
  );
};

export default ProfilePage;

const PageContainer = styled.main`
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-color: #0A0F15;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;

  @media (min-width: 768px) {
    padding: 0 32px;
  }
`;

const ProfileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 0;
  max-width: 800px;
  margin: 0 auto;

  @media (min-width: 1024px) {
    gap: 32px;
    padding: 32px 0;
  }
`;